import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

axios.defaults.timeout = 30000

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/ticket/v3/cms/ticket-management`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const ticket3TicketManagementApi = {
  /**
   * @param {string} request.params.page_id 212669041930795
   * @param {number} request.params.limit 25
   * @param {number} request.params.offset 0
   * @param {string} request.params.start_date 2024-01-01
   * @param {string} request.params.end_date 2024-01-31
   * @param {all | facebook | line} request.params.channel all
   * @param {string} request.params.id OPTIONAL
   * @param {pending| answered} request.params.status OPTIONAL
   * @param {string} request.params.subject OPTIONAL
   * @param {string} request.params.customer_name OPTIONAL
   * @param {string} request.params.group_id OPTIONAL
   * @param {low | medium | high} request.params.priority OPTIONAL
   * @param {string} request.params.tags  test1, test2 OPTIONAL
   * @returns {Promise} { data: { ... } }
   */
  getTicketManagement: (request) => {
    const { params } = request

    const url = `/`
    return instance().get(url, {
      params
    })
  },
  putTransferMultiTicket: (request) => {
    const { data } = request

    const url = `/transfer`
    return instance().put(url, data)
  },
  putTicketManagement: (request) => {
    const { data } = request

    const url = `/`
    return instance().put(url, data)
  },
  getTicketManagementHistory: (request) => {
    const { params } = request

    const url = `/history`
    return instance().get(url, {
      params
    })
  },
  getTicketByStatus: (request) => {
    const { params } = request
    // page_id: 212669041930795
    // start_date: 2024 - 05 - 01
    // end_date: 2024 - 06 - 04
    const url = `/status`
    return instance().get(url, {
      params
    })
  }
}

export default ticket3TicketManagementApi



// WEBPACK FOOTER //
// ./src/api/ticket3/ticket-management.js